function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 20,
  width: 68,
  height: 68,
  rx: 34,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.588 62C52.192 60.3026 50.4053 58.9146 49.672 58C48.4163 56.431 47.6293 54.5393 47.4017 52.5426C47.1741 50.5459 47.5152 48.5256 48.3857 46.7143C49.2562 44.903 50.6206 43.3745 52.3218 42.3047C54.023 41.235 55.9919 40.6676 58.0014 40.668C60.011 40.6683 61.9797 41.2363 63.6806 42.3066C65.3814 43.3768 66.7454 44.9058 67.6153 46.7174C68.4852 48.5289 68.8256 50.5494 68.5974 52.546C68.3692 54.5426 67.5816 56.4341 66.3253 58.0026C65.592 58.916 63.808 60.304 63.412 62H52.5867H52.588ZM63.3333 64.6666V66C63.3333 66.7072 63.0524 67.3855 62.5523 67.8856C62.0522 68.3857 61.3739 68.6666 60.6667 68.6666H55.3333C54.6261 68.6666 53.9478 68.3857 53.4477 67.8856C52.9476 67.3855 52.6667 66.7072 52.6667 66V64.6666H63.3333ZM59.3333 51.34V46L53.3333 54.0066H56.6667V59.34L62.6667 51.34H59.3333Z",
  fill: "#4B617C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 116,
  height: 116,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.334444 0 0 0 0 0.39321 0 0 0 0 0.466667 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.b7e918b4.svg";
export { ForwardRef as ReactComponent };